'use client'

import { type FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconMail } from '@redteclab/icons'

import { Notification } from 'base-ui'

import { NewsletterSubscribeFaq } from '../../newsletter'
import { useNewsletterSubscribeContext } from '../context/NewsletterSubscribeContext'

export const NewsletterSubscribeSuccessContent: FC = () => {
  const [hasResend, setHasResend] = useState(false)
  const [hasError, setHasError] = useState(false)
  const { email, setEmail } = useNewsletterSubscribeContext()

  return (
    <>
      <h1 className="mb-4 text-3xl/3xl font-medium tablet:text-center">
        <FormattedMessage id="newsletter.subscribe.optInSend.headline" />
      </h1>
      <h2 className="mb-4 text-2xl font-medium tablet:text-center">
        <FormattedMessage id="newsletter.subscribe.optInSend.message" />
      </h2>

      {hasError ? (
        <Notification
          className="mb-6"
          data-qa-id="newsletter-subscribe-error-notification"
          severity="error"
        >
          <FormattedMessage id="general.error" />
        </Notification>
      ) : (
        <Notification
          data-qa-id="newsletter-subscribe-success-notification"
          icon={<IconMail />}
          severity="info"
        >
          {hasResend ? (
            <p>
              <FormattedMessage
                id="newsletter.subscribe.optIn.notification.resendMessage"
                values={{
                  email,
                }}
              />
            </p>
          ) : (
            <p>
              <FormattedMessage
                id="newsletter.subscribe.optIn.notification.message"
                values={{
                  email,
                }}
              />
            </p>
          )}
        </Notification>
      )}
      <NewsletterSubscribeFaq
        email={email}
        setEmail={setEmail}
        setHasError={setHasError}
        setHasResend={setHasResend}
      />
    </>
  )
}
